import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from 'api'
import { userCardStore } from 'shared/store/userCard'
import { toaster } from 'uikit/Toaster'

export const useUpdateUser = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: any) => {
      const { id, force, ...data } = payload

      return api.users.updateUser(id, data, { force })
    },
    onSuccess: (data) => {
      userCardStore.setState((state) => ({
        ...state,
        ...data,
      }))

      queryClient.invalidateQueries({ queryKey: ['passportJournal'] })

      toaster.create({
        type: 'success',
        title: 'Данные успешно обновлены',
      })
    },
  })
}
